import { render, staticRenderFns } from "./join.vue?vue&type=template&id=c521d520&scoped=true"
import script from "./join.vue?vue&type=script&lang=js"
export * from "./join.vue?vue&type=script&lang=js"
import style0 from "./join.vue?vue&type=style&index=0&id=c521d520&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c521d520",
  null
  
)

export default component.exports